import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { userQuery } from '../../../core/authentication/queries';
import { useAppSelector } from '../../../types';
import { EmptyProject, TextInformation, Title } from './styles';

// Component used only if projectList is empty but will be implemented later
export const EmptyProjectList: FC = () => {
    const { t } = useTranslation();
    const user = useAppSelector(userQuery);

    return (
        <EmptyProject>
            <TextInformation>
                {t('projectList.welcomeMessage')} {user?.lastName} {user?.firstName} !
            </TextInformation>
            <Title>{t('projectList.emptyProject')}</Title>
        </EmptyProject>
    );
};
